<!--
 * @Author: RYL
 * @Description: 终端信息添加、编辑组件
 * @Date: 2020-10-16 10:24:13
 * @LastEditTime: 2022-03-31 16:26:55
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="
        type === 'edit'
          ? $t('lang.terminalList.Edittheterminaldevice')
          : $t('lang.terminalList.Addaterminaldevice')
      "
      :visible.sync="dialogVisible"
      center
      width="80%"
    >
      <div>
        <el-form
          class="terminal-form"
          :model="terminalData"
          :rules="addRules"
          ref="addTerminal"
          label-width="160px"
          label-position="right"
        >
          <el-divider content-position="left">{{
            $t("lang.terminalList.Fillintheterminalinformation")
          }}</el-divider>
          <el-form-item
            :label="$t('lang.terminalList.Collectionconfigurationtemplate')"
            v-if="terminalData.protocol"
            prop="template"
            class="formItem"
          >
            <el-select
              class="form-input"
              size="mini"
              clearable
              v-model="terminalData.template"
              value-key="id"
            >
              <el-option
                v-for="item in templateList"
                :key="item.id"
                :label="item.name"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.Templatecategory')"
            prop="type"
            class="formItem"
          >
            <el-select
              class="form-input"
              size="mini"
              v-model="terminalData.type"
            >
              <el-option
                v-for="(item, index) in modTypeOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.Protocol')"
            prop="protocol"
            class="formItem"
          >
            <el-select
              class="form-input"
              size="mini"
              v-model="terminalData.protocol"
              @change="protocalChange"
            >
              <el-option
                v-for="(item, index) in protoOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.Equipment')"
            prop="device"
            class="formItem"
          >
            <select-device
              ref="selectDevice"
              :device="terminalData.device"
              @setDeviceSelect="setDeviceSelect"
            ></select-device>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.Name')"
            prop="name"
            class="formItem"
          >
            <el-input
              class="form-input"
              size="mini"
              v-model="terminalData.name"
              clearable
            ></el-input>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :span="8">
              <el-form-item label="工作模式：" prop="model">
                <el-select size="mini" v-model="terminalData.model">
                  <el-option value="1" label="modbus"></el-option>
                  <el-option value="2" label="继电器"></el-option>
                </el-select>
              </el-form-item>
          </el-col>-->
          <!-- <el-col :span="8"> -->
          <el-form-item
            :label="$t('lang.terminalList.SlaveID')"
            v-if="terminalData.protocol != 3"
            prop="sid"
            class="formItem"
          >
            <el-input
              class="form-input"
              size="mini"
              type="number"
              v-model="terminalData.sid"
              clearable
            ></el-input>
            <div style="color: grey; line-height: 15px">
              {{ $t("lang.terminalList.Valuerange") + 255 }}
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.Slaveaddress')"
            v-if="terminalData.protocol == 1"
            prop="ip"
            class="formItem"
          >
            <el-input
              class="form-input"
              size="mini"
              v-model="terminalData.ip"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.Port')"
            v-if="terminalData.protocol == 1"
            prop="port"
            class="formItem"
          >
            <el-input
              class="form-input"
              size="mini"
              type="number"
              v-model="terminalData.port"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.SerialportNo')"
            v-if="terminalData.protocol == 2"
            prop="com"
            class="formItem"
          >
            <el-select
              v-model="terminalData.com"
              clearable
              size="mini"
              class="form-input"
              @change="serialPortChang"
              :no-data-text="comText"
              :placeholder="
                $t('lang.terminalList.Pleaseselecttheequipmentfirst')
              "
            >
              <el-option
                v-for="item in serialPortOptions"
                :key="item.sname"
                :label="item.sname"
                :value="item.sname"
              ></el-option>
            </el-select>
            <div
              style="color: red; line-height: 15px"
              v-if="!terminalData.device.deviceDid"
            >
              {{ $t("lang.terminalList.Pleaseselecttheequipmentfirst") }}
            </div>
          </el-form-item>
          <el-divider
            content-position="left"
            v-if="terminalData.protocol == 2"
            >{{
              $t("lang.terminalList.Configureserialportinformation")
            }}</el-divider
          >
          <el-form-item
            :label="`${$t('lang.smartlink.baudRate')}：`"
            prop="bps"
            v-if="terminalData.protocol == 2"
          >
            <el-select
              size="mini"
              v-model="terminalData.bps"
              clearable
              class="form-input"
            >
              <el-option
                v-for="(item, index) in BaudRateList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="`${$t('lang.smartlink.dataBits')}：`"
            prop="dataBit"
            v-if="terminalData.protocol == 2"
          >
            <el-select
              allow-create
              filterable
              default-first-option
              size="mini"
              v-model="terminalData.dataBit"
              clearable
              class="form-input"
            >
              <el-option
                v-for="(item, index) in DataBitList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="`${$t('lang.smartlink.stopBits')}：`"
            prop="stopBit"
            v-if="terminalData.protocol == 2"
          >
            <el-select
              size="mini"
              filterable
              allow-create
              default-first-option
              v-model="terminalData.stopBit"
              clearable
              class="form-input"
            >
              <el-option
                v-for="(item, index) in StopBitList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="`${$t('lang.smartlink.checkBits')}：`"
            prop="checkBit"
            v-if="terminalData.protocol == 2"
          >
            <el-select
              size="mini"
              v-model="terminalData.checkBit"
              clearable
              class="form-input"
            >
              <el-option
                v-for="(item, index) in CheckDigitList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="`${$t('lang.smartlink.flowControl')}：`"
            prop="xon"
            v-if="terminalData.protocol == 2"
          >
            <el-select
              class="form-input"
              size="mini"
              v-model="terminalData.xon"
              clearable
            >
              <el-option
                v-for="(item, index) in FlowControlList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">{{
          $t("lang.terminalList.Cancel")
        }}</el-button>
        <el-button size="mini" type="primary" @click="submitAdd">{{
          $t("lang.terminalList.Confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDeviceList } from "@/api/cloudMonitor/deviceList";
import {
  addTerminal,
  terminalDetail,
  editTerminal,
  monitor,
  monitorTerminal,
} from "@/api/cloudMonitor/terminalList";
import { listConfig, updateConfig } from "@/api/configurationlist";
import { terminalForm } from "@/mixins/terminalForm";
import { getTemplate } from "@/api/cloudMonitor/templateList";
import selectDevice from "./selectDevice";
import { cloneDeep, isEqual } from "lodash";
import {
  BaudRateList,
  DataBitList,
  StopBitList,
  CheckDigitList,
  FlowControlList,
} from "@/utils/com.js";
export default {
  components: {
    selectDevice,
  },
  mixins: [terminalForm],
  data() {
    return {
      dialogVisible: false,
      deviceSelection: "", // 选择的所属设备
      type: "", // 编辑还是添加
      comIndex: 0, // 串口下标
      loading: false,
      startEdit: false,
      editFlag: {
        comFlag: false, //串口配置修改是否成功
        monitorFlag: false, //下发指令是否成功
        terminalMonitor: false, // 终端基本信息是否采集成功
      },
      BaudRateList, //波特率选项
      DataBitList, //数据位选项
      StopBitList, //停止位选项
      CheckDigitList, //校验位选项
      FlowControlList, //流控选项
      originalDevice: "", //原设备
    };
  },
  watch: {
    editFlag: {
      // immediate: true,
      deep: true,
      handler() {
        if (
          this.editFlag.comFlag === true &&
          this.editFlag.monitorFlag === true &&
          this.editFlag.terminalMonitor === true
        ) {
          if (this.type === "edit") {
            this.$message.success(
              this.$t("lang.terminalList.Successfullymodified")
            );
          } else {
            this.$message.success(
              this.$t("lang.terminalList.Successfullyadded")
            );
          }
          this.dialogVisible = false;
        }
      },
    },
    watchDevice: {
      immediate: true,
      deep: true,
      handler() {
        if (this.terminalData.device.deviceDid) {
          this.serialPortOptions = [];
          this.serialPortData = [];
          this.getConfig();
        }
      },
    },
    "terminalData.type": {
      immediate: false,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue == 0) {
          this.protoOptions = [];
          this.protoOptions.push({ label: "Modbus TCP", value: "1" });
          this.protoOptions.push({ label: "Modbus RTU", value: "2" });
          this.terminalData.protocol =
            this.terminalData.protocol == 3 ? "1" : this.terminalData.protocol;
        } else {
          this.protoOptions = [];
          this.protoOptions.push({ label: "IO Control", value: "3" });
          this.terminalData.protocol = "3";
        }
        this.getTemplateList();
      },
    },
  },
  computed: {
    watchDevice() {
      return this.terminalData.device;
    },
  },
  methods: {
    // 显示弹窗
    show(item, type) {
      this.clearData();
      this.dialogVisible = true;
      this.editFlag = {
        comFlag: false, //串口配置修改是否成功
        monitorFlag: false, //下发指令是否成功
        terminalMonitor: false,
      };
      this.getTemplateList();
      if (type === "edit") {
        this.type = "edit";
        // 获取终端详情回显
        terminalDetail({ id: item }).then((res) => {
          if (res.data.code === 0) {
            this.originalDevice = res.data.data.dsn;
            this.handleData(res.data.data);
            // 处理采集配置模板的数据
            this.$set(this.terminalData, "template", { id: "" });
            this.$set(this.terminalData.template, "id", res.data.data.mid);
            this.$set(this.terminalData, "device", { deviceDid: "" });
            this.$set(this.terminalData, "port", 502);
            // this.$set(this.terminalData, 'model','1')
            this.$set(this.terminalData.device, "deviceDid", res.data.data.did);
            this.$set(this.terminalData.device, "deviceSn", res.data.data.dsn);
            this.$set(
              this.terminalData.device,
              "deviceName",
              res.data.data.dname
            );
            this.originalTemplate = this.terminalData.template;
            this.originalPotocol = this.terminalData.protocol;
          } else {
            this.$message.error(this.$t("lang.terminalList.Requestfailed"));
          }
          this.dialogVisible = true;
        });
      } else {
        this.type = "add";
        this.terminalData.port = 502;
        if (item && item.deviceId) {
          // 从设备路由传过来的设备Id
          this.$nextTick(() => {
            this.terminalData.device = item;
          });
        }
      }
    },
    // 协议发生变化
    protocalChange(val) {
      this.resetValidate();
    },

    // 获取模板列表
    getTemplateList() {
      let params = {
        current: 1,
        size: 99999,
      };
      getTemplate(params)
        .then((res) => {
          let data = res.data.data;
          if (res.data.code === 0) {
            this.templateList = data.records.filter(
              (v) => v.type == this.terminalData.type
            );
          }
        })
        .catch(() => {});
    },
    // 修改串口配置
    updateCom() {
      if (this.terminalData.protocol == 2) {
        let arr = [
          {
            section: "serial",
            config: "smartlink",
            action: 0,
            index: [this.comIndex],
            options: {
              parity: this.terminalData.checkBit,
              data_bits: this.terminalData.dataBit,
              stop_bits: this.terminalData.stopBit,
              flow_ctrl: this.terminalData.xon,
              baudrate: this.terminalData.bps,
            },
          },
        ];
        updateConfig(
          this.terminalData.device.deviceSn,
          this.terminalData.device.deviceDid,
          arr
        )
          .then((res) => {
            if (res.data.code === 0) {
              this.editFlag.comFlag = true;
            } else {
              this.editFlag.comFlag = false;
              this.$message.error(
                this.$t("lang.terminalList.Serialportconfigurationfailed")
              );
            }
          })
          .catch(() => {
            this.editFlag.comFlag = false;
            this.$message.error(
              this.$t("lang.terminalList.Serialportconfigurationfailed")
            );
          });
      }
    },
    // 下发采集变量指令
    updateMonitor(id) {
      let type = "";
      this.templateList.forEach((v) => {
        console.log(v);
        if (v.id == this.terminalData.template.id) {
          type = v.type;
        }
      });

      let data = {
        dtuId: id,
        // vids
        type,
      };
      monitor(data)
        .then((res) => {
          if (res.data.code === 0) {
            this.editFlag.monitorFlag = true;
          } else {
            this.editFlag.monitorFlag = false;
            this.$message.success(
              this.$t("lang.terminalList.Failedtoissuethecommand")
            );
          }
        })
        .catch((err) => {
          this.editFlag.monitorFlag = false;
          this.$message.error(
            this.$t("lang.terminalList.Failedtoissuethecommand")
          );
        });
    },
    // 采集终端信息
    terminalMonitor(id, action) {
      let params = {
        dtuId: id,
        action: action,
      };
      // 采集终端信息
      monitorTerminal(params)
        .then((res) => {
          if (res.data.code === 0) {
            this.editFlag.terminalMonitor = true;
          } else {
            this.editFlag.terminalMonitor = false;
            this.$message.warning(
              this.$t("lang.terminalList.Collectionfailed")
            );
          }
        })
        .catch(() => {
          this.$message.warning(
            this.$t("lang.terminalList.Collectionrequesterror")
          );
          this.editFlag.terminalMonitor = false;
        });
    },
    // 提交表单
    async submitAdd() {
      this.$refs.addTerminal.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.type === "edit") {
            // 添加所属设备必选
            this.terminalData.did = this.terminalData.device.deviceDid;
            console.log(this.terminalData);
            let submitData = this.setSubmitData(this.terminalData);
            // 没有修改模板就不传模板id
            if (isEqual(this.originalTemplate.id, submitData.mid)) {
              submitData.mid = undefined;
            }
            this.$set(submitData, "proType", this.originalPotocol);
            this.$set(submitData, "dsn", this.terminalData.device.deviceSn);
            editTerminal(submitData)
              .then((res) => {
                if (res.data.code === 0) {
                  this.startEdit = true;
                  // 成功后要同时修改串口配置
                  if (this.terminalData.protocol == 2) {
                    // this.updateCom()
                    this.editFlag.comFlag = true;
                  } else {
                    this.editFlag.comFlag = true;
                  }
                  if (
                    !isEqual(this.terminalData.template, this.originalTemplate)
                  ) {
                    this.updateMonitor(this.terminalData.id);
                  } else {
                    this.editFlag.monitorFlag = true;
                  }
                  this.terminalMonitor(
                    this.terminalData.id,
                    this.originalDevice == this.terminalData.device.deviceSn
                      ? 0
                      : 1
                  );
                  this.$emit("updateList");
                } else {
                  this.$message.error(
                    this.$t("lang.terminalList.Addingfailed")
                  );
                }
              })
              .catch(() => {});
          } else {
            if (this.terminalData.device.deviceDid) {
              this.terminalData.did = this.terminalData.device.deviceDid;
              let submitData = this.setSubmitData(this.terminalData);
              this.$set(submitData, "dsn", this.terminalData.device.deviceSn);
              addTerminal(submitData)
                .then((res) => {
                  if (res.data.code === 0) {
                    // 成功后要同时修改串口配置
                    if (this.terminalData.protocol == 2) {
                      // this.updateCom()
                      this.editFlag.comFlag = true;
                    } else {
                      this.editFlag.comFlag = true;
                    }
                    // 同时要采集指令
                    this.updateMonitor(res.data.data);
                    this.terminalMonitor(res.data.data, 1);
                    this.$emit("updateList");
                  } else if (res.data.code === 51) {
                    this.$message({
                      message: res.data.message,
                      type: "warning",
                    });
                  } else {
                    this.$message.error(
                      this.$t("lang.terminalList.Addingfailed")
                    );
                  }
                })
                .catch((err) => {});
            } else {
              this.$message.warning(this.$t("lang.terminalList.Notselected"));
            }
          }
        } else {
          this.$message.warning(this.$t("lang.terminalList.Incorrectfilling"));
          return false;
        }
      });
    },
    // 设备选项
    setDeviceSelect(val) {
      this.terminalData.device = val;
    },
  },
};
</script>
<style scoped>
.form-input {
  width: 80%;
}
.terminal-form {
  display: flex;
  flex-wrap: wrap;
}
.formItem {
  width: 460px;
}
</style>
